import { ComentarioModel } from './ws-comentario';

export interface ITicket {
    IdTicket: number;
    Contacto: string;
    ContactoEmail: string;
    Asunto: string;
    Prioridad: string;
    Canal: string;
    Asignado: string;
    Fecha: string;
    IdEstado: number;
    Estado: string;
    FlagRequerimiento: boolean;
    Calificacion: number;
    CalificacionObs: string;
}

export class TicketModel {
    IdTicket: number;
    Contacto: string;
    ContactoEmail: string;
    Asunto: string;
    Prioridad: string;
    Canal: string;
    Asignado: string;
    Fecha: string;
    IdEstado: number;
    Estado: string;
    FlagRequerimiento: boolean;
    Calificacion: number;
    CalificacionObs: string;

    constructor(data?: ITicket) {
        if (data) {
            this.IdTicket = data.IdTicket;
            this.Contacto = data.Contacto;
            this.ContactoEmail = data.ContactoEmail;
            this.Asunto = data.Asunto;
            this.Prioridad = data.Prioridad;
            this.Canal = data.Canal;
            this.Asignado = data.Asignado;
            this.Fecha = data.Fecha;
            this.IdEstado = data.IdEstado;
            this.Estado = data.Estado;
            this.FlagRequerimiento = data.FlagRequerimiento;
            this.Calificacion = data.Calificacion;
            this.CalificacionObs = data.CalificacionObs;
        }
    }
}

/* individual */
export class TicketByIDModel {
    IdTicket: number;
    TipoIngreso: number;
    IdEstado: number;
    IdLinea: number;
    LineaNegocioAbreviado: string;
    IdPrioridad: number;
    Asunto: string;
    IdCliente: number;
    // ClienteNumDoc: string;
    // ClienteCodCipsa: string;
    // RazonSocial: string;
    // IdContacto: number;
    // TipoContacto: string;
    // Nombre: string;
    // Cargo: string;
    // Area: string;
    // Email: string;
    // Telf: string;
    // Anexo: string;
    IdPersonalDerivado: number;
    PersonalDerivado: string;
    PerDerivadoPuesto: string;
    TiempoTranscurrido: number;
    // IdPersonalSolicitante: number;
    // PersonalSolicitante: string;
    // ProximaAlerta: string;
    // AnotacionInterna: string;
    // IdBolsaTiempo: number;
    // Horas: number;
    // TiempoEfectivo: number;
    // VigenciaFin: string;
    // Motivo: string;
    // Factura: string;
    // IdPersonalRegistro: number;
    // PersonalRegistro: string;
    FechaRegistro: string;
    FlagRequerimiento: boolean;
    Calificacion: number;
    CalificacionObs: string;
    Observacion: string;

    // Listas
    Contactos: [];
    Incidencias: [];
    Comentarios: ComentarioModel[];
    Archivos: [];
    ArchivosFromWeb: [];
    Encuesta: any;

    constructor(data: any) {
        if (data) {
            this.IdTicket = data.IdTicket;
            this.TipoIngreso = data.TipoIngreso;
            this.IdEstado = data.IdEstado;
            this.IdLinea = data.IdLinea;
            this.LineaNegocioAbreviado = data.LineaNegocioAbreviado;
            this.IdPrioridad = data.IdPrioridad;
            this.Asunto = data.Asunto;
            this.IdCliente = data.IdCliente;
            // this.ClienteNumDoc = data.ClienteNumDoc;
            // this.ClienteCodCipsa = data.ClienteCodCipsa;
            // this.RazonSocial = data.RazonSocial;
            // this.IdContacto = data.IdContacto;
            // this.TipoContacto = data.TipoContacto;
            // this.Nombre = data.Nombre;
            // this.Cargo = data.Cargo;
            // this.Area = data.Area;
            // this.Email = data.Email;
            // this.Telf = data.Telf;
            // this.Anexo = data.Anexo;
            this.IdPersonalDerivado = data.IdPersonalDerivado;
            this.PersonalDerivado = data.PersonalDerivado;
            this.PerDerivadoPuesto = data.PerDerivadoPuesto;
            this.TiempoTranscurrido = data.TiempoTranscurrido;
            // this.IdPersonalSolicitante = data.IdPersonalSolicitante;
            // this.PersonalSolicitante = data.PersonalSolicitante;
            // this.ProximaAlerta = data.ProximaAlerta;
            // this.AnotacionInterna = data.AnotacionInterna;
            // this.IdBolsaTiempo = data.IdBolsaTiempo;
            // this.Horas = data.Horas;
            // this.TiempoEfectivo = data.TiempoEfectivo;
            // this.VigenciaFin = data.VigenciaFin;
            // this.Motivo = data.Motivo;
            // this.Factura = data.Factura;
            // this.IdPersonalRegistro = data.IdPersonalRegistro;
            // this.PersonalRegistro = data.PersonalRegistro;
            this.FechaRegistro = data.FechaRegistro;
            this.FlagRequerimiento = data.FlagRequerimiento;
            this.Calificacion = data.Calificacion;
            this.CalificacionObs = data.CalificacionObs;
            this.Observacion = data.Observacion;

            this.Contactos = data.Contactos;
            this.Incidencias = data.Incidencias;
            this.Comentarios = data.Comentarios.map((item: any) => new ComentarioModel(item));
            this.Archivos = data.Archivos;
            this.ArchivosFromWeb = data.ArchivosFromWeb;
            this.Encuesta = data.Encuesta;
        }
    }
}